// Settings → Master Menu: the Active / Inactive badge on a product row is a switch.
// Picking the other value saves that one field and nothing else; the list on screen
// changes at once and goes back if the save fails.

type ListedProduct = { id: number; isActive: boolean };

/** The request a badge pick sends: the product's own PATCH, carrying `isActive` alone. */
export function productActiveRequest(id: number, isActive: boolean): { path: string; body: { isActive: boolean } } {
  return { path: `/api/products/${id}`, body: { isActive } };
}

/** The cached product list with one product switched; every other row is the same object. */
export function withProductActive<P extends ListedProduct>(products: P[] | undefined, id: number, isActive: boolean): P[] | undefined {
  if (!products) return products;
  return products.map((product) => (product.id === id ? { ...product, isActive } : product));
}
